import { isDisplayPeriod } from "utility";
import { isShippingItem } from "utility/ticket";

import type { ProductData } from "@spwn/types/firebase/firestore";

/** ライブコマースに並べる商品を、表示期間で絞って新しい順・優先度順に並べる */
export const selectLiveCommerceGoods = (
  goods: ProductData[],
  isAdmin: boolean
): ProductData[] =>
  goods
    .filter(
      (item) =>
        (isDisplayPeriod(
          item.display,
          item.releaseDateTime,
          item.closeDateTime
        ) &&
          isShippingItem(item)) ||
        (item.display && isAdmin)
    )
    .sort(
      (prev, cur) =>
        cur.releaseDateTime.seconds - prev.releaseDateTime.seconds ||
        prev.priority - cur.priority
    );
